import Vue from 'vue';
import app from './app.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css';
import bridge from '@vkontakte/vk-bridge'; 

// Инициализация VK Bridge
bridge.send('VKWebAppInit');

// eslint-disable-next-line no-unused-vars
window.gkSettingsPhpUrl = 'http://81.94.140.194:8091';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(app)
}).$mount('#app');
